import SSSlideDisplayer from './00-slideshare_slide_displayer';
import { isIos } from '../mobile/02-mobile_devices';

function SSPresentationDisplayer(config){
  if (typeof config === "undefined"){
    return;
  }
  SSSlideDisplayer.call(this, config);
  this.zoomLevels = [1];
  this.prerenderedSlides = [];
  !config.isTouch && this.initPointlyFinger();
}

SSPresentationDisplayer.prototype = new SSSlideDisplayer();

SSPresentationDisplayer.prototype.initPointlyFinger = function(){
  this.rightbandInteraction = $('<div/>').attr({
     'class' : 'rightpoint pointly'
  }).appendTo(this.container.first());
  this.leftbandInteraction = $('<div/>').attr({
    'class' : 'leftpoint pointly'
  }).appendTo(this.container.first()); 
};

SSPresentationDisplayer.prototype._scrollTo = function(index){
  if (this.state !== 'playing'){
    return;
  }
  if(this.config.show_image_player){
    var slides = this.slidesContainer.children();
    slides.removeClass("show");
    slides.eq(index - 1).addClass("show");
    return;
  }
  var ios = typeof isIos == 'function' && isIos();
  var leftOffset = (this.slideOffsets[index]) * -1 ;
  var experiment = false;
  if(experiment && ios){
    // Swipe animation in ios ain't smooth , so using hardware accilaration.
    this.slidesContainer.css({
       '-webkit-transform': 'translateX(' + leftOffset + 'px)',
       '-webkit-transition': '-webkit-transform 275ms ease-in-out'
    });
  }else{
   this.slidesContainer.css('margin-left',  leftOffset);
  }

};

SSPresentationDisplayer.prototype.start = function(config){
  var i, slide;
  if(this.slideContainers === undefined){
     this.slideContainers = [];
  }
  var slideContainers = this.slideContainers;

  if (this.slides === undefined){
    this.slides = config.slides;
    this.state = 'playing';
    this.hideInitializer();

    this.slidesContainer = this.config.show_image_player ? $('.slide_container') : $('<div/>').appendTo(this.container);

    for (i=1; i<=this.config.slideCount; i++){
      slideContainers[i] = this.config.show_image_player ? $('.slide').eq(i-1): $('<div/>').appendTo(this.slidesContainer) ;
    }
  }

 !this.config.show_image_player && this.slidesContainer.removeClass(this.playerBgColor).addClass('slidesContainer ' + config.playerBgColor);
  if(config.playerBgColor){
    this.slidesContainer.removeClass(this.playerBgColor);
    this.playerBgColor = config.playerBgColor;
    this.slidesContainer.addClass(this.playerBgColor);
  }

  for(i=1; i<=this.config.slideCount; i++){
    slide = this.slides[i];
    slide.setContainer({
      mode : config.mode,
      container: slideContainers[i],
      bgColor: this.playerBgColor,
      slideNumber: i
    });
  }
};

SSPresentationDisplayer.prototype.showInitializer = function(){
  var top, left;
  top = this.container.height()/2 - 16;
  left = this.container.width()/2 - 16;

  $('<img/>').attr({src: this.config.spinnerUrl, 'class': 'jsplInitializer'}).css({
    width: 32,
    height: 32,
    top : top,
    left : left
  }).appendTo(this.container);
};

SSPresentationDisplayer.prototype.setDimensions = function(dimensions){
  var that = this;
  if (typeof dimensions === 'object'){
    this.config.width = dimensions.width;
    this.config.height = dimensions.height;
  }
  var partialUpdate = dimensions && dimensions.partial;

  // we want the container to take up only allowed slideheight. However, it should scale to fit
  // available width so that the scrollbars are at the edge. This appies only for documents
  // !this.config.show_image_player && this.container.css({
  //   height : this.config.height,
  //   width : this.config.width
  // });

  // Set slide max-height for responsive behavior
  if (this.config && this.config.width) {
    var firstSlide = document.querySelector('.slide_image');
    var maxHeight = firstSlide.naturalHeight * this.config.width / firstSlide.naturalWidth;
    var $player = $('.lightPlayer').not('.embed_player');
    // The player navbar has a height of 56px
    $player.css({
      maxHeight: maxHeight + 50.5,
    });
  }

  if (!partialUpdate && this.state === 'playing'){
    this.panelWidth = 0;
    var i, slide, offset;
    offset = 0;
    for(i=1;i<=this.config.slideCount; i++){
      slide = this.slides[i];
      !this.config.show_image_player && slide.setDimensions({
        parentHeight: this.config.height,
        parentWidth : this.config.width
      });
      this.slideOffsets[i] = offset;
      offset += slide.wrapperOffset();
    }

    //caching size values from jQuery for detectCurrentSlide optimizations
    this.slidesContainer.width(offset);
    this.width = offset;
  }
};

SSPresentationDisplayer.prototype.setPrerenderedSlides = function(config){
  var i;
  for (i=config.start; i<=config.end; i++){
    if ($.inArray(i, this.prerenderedSlides) === -1){
      this.prerenderedSlides.push(i);
    }
  }
};

SSPresentationDisplayer.prototype.emptySlides = function(){
  var i;
  for(i in this.slides){
    var slides = this.slides;
    if(slides.hasOwnProperty(i)){
      var slide = slides[i];
      slide.hide();
    }
  }
  this.prerenderedSlides = [];
};

export default SSPresentationDisplayer;
